import { Flex } from 'components/Flex';
import styled from 'styled-components';

export const GeneralSettingsContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: baseline;
  max-width: 100%;
  width: 80%;
  flex-grow: 1;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 24px;
`;

export const FlexWrapper = styled(Flex)`
  background-color: white;
`;

export const SubHeader = styled.div`
  color: ${({ theme }) => theme.colors.AccentPurple};
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
`;

export const LastChangedFooter = styled.div`
  ${({ theme }) => theme.fonts.PoppinsText};
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  font-size: 14px;
  line-height: 21px;
  padding-top: 10px;
  margin-bottom: 24px;
`;

export const EditButtonWrapper = styled(Flex)`
  justify-content: flex-end;
  padding-bottom: 20px;
`;

export const SettingsTable = styled(Flex)`
  border-top: 2px solid ${({ theme }) => theme.colors.Grey5};
`;

export const SettingsRow = styled(Flex)<{ $grey?: boolean }>`
  width: 100%;
  min-height: 72px;
  padding: 12px 16px;
  background-color: ${({ theme, $grey }) => ($grey ? theme.colors.Grey1 : '#ffffff')};
  border-bottom: 1px solid ${({ theme }) => theme.colors.Grey5};
`;

export const SettingsRowLabel = styled(Flex)`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const SettingsRowValue = styled(Flex)`
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  text-align: right;
`;

export const SettingsRowSubValue = styled.div`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  font-size: 14px;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
`;

export const NotificationLabel = styled.div`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const NotificationDescription = styled.div`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 14px;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
`;

export const ManagedByDropdownWrapper = styled.div`
  width: 100%;
  max-width: 340px;
`;
